import psychologyClient from '@/axiosClients/psychologyClient';
import psychologyResilienceClient from '@/axiosClients/psychologyResilienceClient';
import { errorHttpMessage } from '@/utils/errorDecodeUtil';

const getAvailableDates = (data) => {
    return psychologyClient.get(`date-availables/${data.id}/${data.startDate}/${data.endDate}?timezone=${data.timezone}`)
}
const getMachingV2 = (data) => {
    return psychologyClient.get(`matching/subsequent-quote?session_type=${data.sessionType}&timezone=${data.timezone}${data.patientId ? '&patient_id=' + data.patientId : ''}`);
}

const getPsychologistById = (id) => {
    return psychologyClient.get(`${id}`);
}

const saveInterested = (data) => {
    return psychologyClient.post(`interested-psychologits`, data);
}

const saveClientComments = (data) => {
    return psychologyClient.post(`client-comments`, data);
}

const saveClientCommentsV2 = (data) => {
    return psychologyClient.post(`client-comments-v2`, data);
}

const getPsychologistsList = () => {
    return psychologyClient.get('psychologists-list');
}

const getImpactCases = (page = 1, pageLength = 1) => {
    return psychologyClient.get(`impact-cases?page=${page}&pageLength=${pageLength}`);
}

const unwrapClinicalNotesCryptoBody = (body) => {
    const envelope = body?.result;
    return {
        data: envelope?.data ?? null,
        error: Boolean(envelope?.error),
        message: envelope?.message ?? null
    };
};

const clinicalNotesCryptoRequest = async (request) => {
    try {
        const { data: body } = await request();
        return unwrapClinicalNotesCryptoBody(body);
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {
            data: null,
            error: true,
            message: error_http_message.message,
            error_keys: error_http_message.error_keys
        };
    }
};

/**
 * Estado de cifrado E2E de notas clínicas (psicólogo).
 * GET .../psychology/resilience/v1/clinical-notes/crypto/status
 */
const getClinicalNotesCryptoStatus = async () =>
    clinicalNotesCryptoRequest(() => psychologyResilienceClient.get('clinical-notes/crypto/status'));

/**
 * Persistir envelopes iniciales (PIN + recuperación).
 * POST .../psychology/resilience/v1/clinical-notes/crypto/envelopes
 */
const postClinicalNotesCryptoEnvelopes = async (enrollmentPayload) =>
    clinicalNotesCryptoRequest(() =>
        psychologyResilienceClient.post('clinical-notes/crypto/envelopes', enrollmentPayload)
    );

/**
 * Envelopes guardados para desbloquear master_key.
 * GET .../psychology/resilience/v1/clinical-notes/crypto/envelopes
 */
const getClinicalNotesCryptoEnvelopes = async () =>
    clinicalNotesCryptoRequest(() =>
        psychologyResilienceClient.get('clinical-notes/crypto/envelopes')
    );

/**
 * Notas legacy en plaintext para migrarlas a E2E en cliente.
 * GET .../psychology/resilience/v1/clinical-notes/crypto/legacy-plaintext-export
 */
const getClinicalNotesLegacyPlaintextExport = async () =>
    clinicalNotesCryptoRequest(() =>
        psychologyResilienceClient.get('clinical-notes/crypto/legacy-plaintext-export')
    );

/**
 * Persistir notas ya cifradas en cliente (migración legacy -> E2E).
 * POST .../psychology/resilience/v1/clinical-notes/crypto/e2e-bulk
 */
const postClinicalNotesCryptoE2EBulk = async (bulkPayload) =>
    clinicalNotesCryptoRequest(() =>
        psychologyResilienceClient.post('clinical-notes/crypto/e2e-bulk', bulkPayload)
    );

export default {
    getAvailableDates,
    getMachingV2,
    getPsychologistById,
    saveInterested,
    saveClientComments,
    saveClientCommentsV2,
    getPsychologistsList,
    getImpactCases,
    getClinicalNotesCryptoStatus,
    postClinicalNotesCryptoEnvelopes,
    getClinicalNotesCryptoEnvelopes,
    getClinicalNotesLegacyPlaintextExport,
    postClinicalNotesCryptoE2EBulk
};
